<template>
  <div>
    <c-textarea
      v-if="field.multiline"
      v-model="localValue"
      :floating-label="field.name"
      :clearable="true"
      :required-mark="field.required"
      :max-length="maxLength"
      :invalid="!!error"
      :error="error"
    />
    <c-input
      v-else
      v-model="localValue"
      :floating-label="field.name"
      :clearable="true"
      :required-mark="field.required"
      :max-length="maxLength"
      :required="error"
      :required-message="error"
    />
  </div>
</template>

<script>
import CInput from "@/components/controls2/Input";
import CTextarea from "@/components/controls/textarea";

export default {
  components: { CInput, CTextarea },
  props: ["field", "value", "editable", "error"],
  data() {
    return {
      inited: false,
      localValue: "",
    };
  },
  computed: {
    maxLength() {
      if (this.field.maxLength) return this.field.maxLength;
      return false;
    },
  },

  watch: {
    localValue(v) {
      this.$emit("input", { value: v });
      if (this.inited) this.$emit("change");
    },
    value(v) {
      this.setData(v);
    },
  },

  created() {
    if (this.value) this.setData(this.value);
  },

  methods: {
    setData(value) {
      if (!value) return;
      this.inited = false;
      this.localValue = value.value;
      this.$nextTick(() => {
        this.inited = true;
      });
    },
  },
};
</script>
